import { createSlice } from "@reduxjs/toolkit";
import { getWalletTransactions } from "../../actions/wallet/transactions";

export const getTransactionSlice = createSlice({
  name: "getTransaction",
  initialState: {
    loading: false,
    success: false,
    error: false,
    errors: null,
    transactions: [],
  },
  reducers: {
    clearState: (state) => {
      state.success = true;
      state.error = false;
      state.errors = null;
      state.loading = false;
      return state;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getWalletTransactions.pending, (state) => {
        state.loading = true;
        return state;
      })
      .addCase(getWalletTransactions.fulfilled, (state, { payload }) => {
        state.success = true;
        state.transactions = payload;
        state.error = false;
        state.errors = null;
        state.loading = false;
        return state;
      })
      .addCase(getWalletTransactions.rejected, (state, { payload }) => {
        state.success = false;
        state.error = true;
        state.loading = false;
        // state.errors = payload.error || payload;
        return state;
      });
  },
});

export const { clearState } = getTransactionSlice.actions;

export const getTransactionSelector = (state) => state.getTransaction;
